import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './plugins/router'
import './plugins/vuesession'


Vue.config.productionTip = false
Vue.config.pluginOptions = {
  proxy: {
    enabled: true,
    context :'/auth',
    options: {
      target: 'http://localhost:8000/'
    }
  }
}

export const bus =new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
